/**
 *
 * This is an empty theme with all of the themable pantheon
 * components listed as keys. Add/remove any components or styles as needed.
 * Styling within the theme follows the same standard key: value; syntax as
 * css/styledcomponents do!
 * For more on how to use theming, check out
 * https://minerva-analytics.atlassian.net/wiki/spaces/PAN/pages/342130759/How+to+Use+Theming
 *
 **/
import { MOBILE } from "@minerva-analytics/pantheon";

// *******************************************
//
// Colors
//
// *******************************************

// Footer Background Color
// Banner on top of content cards, legal card
// Middle content card on about page
// Hamburger Menu Background on Tablet and smaller
export const PRIMARY_COLOR = "#022348";

// Subscribe Button
// Top banner
// Title text - about us
// Icon colors - contact page
// Link color - legal
export const SECONDARY_COLOR = "#08a4d4";

// Text Color for most text blurbs
// SubscribeForm, About Page 1st and 3rd
// Confirmation page, ContactUs blurb, Home blurb
// All of Legal
export const BODY_TEXT_COLOR = "#323232";

// Footer Text color
// Menu text color - tablet or smaller
// Button text color
// Color of text in middle about section
export const FOOTER_COLOR = "#FFFFFF";

// Title font color
export const TITLE_COLOR = "#012348";

// Subscribe border
export const BORDER_COLOR = "#979797";

// Email highlight color
export const HIGHLIGHT_COLOR = "#F24236";

export const TRANSPARENT = `transparent`;

export const BACKGROUND_COLOR = "#FFFFFF";
export const BACKGROUND_RIGHT_COLOR = "#EEFCFF";
export const SECONDARY_BACKGROUND_COLOR = "#08a4d4";
export const TERTIARY_BACKGROUND_COLOR = "#012348";

// Legal
export const GRAY_LEGAL_HEADER = "#6C6C6C";
export const GRAY_LEGAL_BODY = "#474747";

// Contact
export const CONTACT_CARD = "#FFFFFF";

export const HOVER_COLOR = "#022348";

// *******************************************
//
// Fonts
//
// *******************************************

// Main font style used across the site
// BodyText, SubTitle,
// Font used for most text blurbs
// Buttons, BodyTextLarge, Footer, About Page
// Legal Pages
export const PRIMARY_FONT_TEXT = "Bitter";

// Font used for all Titles
export const TITLE_FONT = "Poppins, sans-serif";

// Font used in header items
export const HEADER_FONT = "Source Sans Pro, sans-serif";

// Font used on the contact form for the email, phone, and address only
export const CONTACT_FONT = "Poppins, sans-serif";

// *******************************************
//
// Themes
//
// *******************************************

const starterTheme = {
  AppLink: `

  `,
  Background: `
    color: ${BACKGROUND_COLOR};
  `,
  BodyText: `
    font-family: '${PRIMARY_FONT_TEXT}';
    line-height: 33px;
    font-size: 18px;
    color: ${BODY_TEXT_COLOR};
    text-align: left;
    letter-spacing: 0.68px;
  `,
  Card: `
    padding: 3rem 0;
    max-width: 40rem;
    width: 90%;
    margin-bottom: 2.5rem;
    box-sizing: border-box;
  `,
  Button: `
    font-family: ${PRIMARY_FONT_TEXT};
    font-weight: 900;
    letter-spacing: 0.5px;
    background-color: ${SECONDARY_COLOR};
  `,
  ExternalLink: `
    font-size: 18px;
  `,
  Image: `
    @media (max-width: ${MOBILE}){
      width: 300px;
    }
  `,
  Input: `
    border: none;
    font-family: ${PRIMARY_FONT_TEXT};
    font-size: 16px;
    margin-right: 15px;
    @media (max-width: ${MOBILE}){
      margin-right: 0px;
      margin-bottom: 15px;
    }
  `,
  LoadingSpinner: `

  `,
  Logo: `
    padding-left: 20px;
    height: 47px;
    width: 20%;
    @media (max-width: ${MOBILE}){
      width: 10%;
    }
  `,
  PiwikButton: `

  `,
  Title: `
    margin: 1rem 0;
    color: ${TITLE_COLOR};
    text-align: left;
    font-family: ${TITLE_FONT};
    font-weight: bold;
    font-size: 50px;
    letter-spacing: 1.05px;

    @media (max-width: ${MOBILE}){
      font-size: 1.75rem;
    }
  `,
  H3: `
    font-weight: 400;
    font-size: 1.5rem;
    margin: 0;
  `,
  BodyTextLarge: `
    font-weight: 400;
    font-family: ${PRIMARY_FONT_TEXT};
    font-size: 18px;
    line-height: 33px;
    letter-spacing: 0.68px;
    text-align: left;
    color: ${BODY_TEXT_COLOR};
  `,
  SocialPageButton: `

  `,
  SubTitle: `
    font-size: 1rem;
    font-weight: 400;
    color: ${BODY_TEXT_COLOR};
    font-family: '${PRIMARY_FONT_TEXT}';
    letter-spacing: 0.6px;
    line-height: 33px;
  `,
  BurgerMenu: `
  `,
  Footer: `
  `,
  CopyrightText: `
    &&&& {
      color: ${FOOTER_COLOR};
      font-size: 90px;
    }
  `,
};

export { starterTheme };
